export default __webpack_public_path__ + "static/media/Bandeau 16.fd351628.jpg";